import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const augustMap: Array<IPixelMapDay> = [
	{
		status: "below-average",
		reason: "In the morning, I was feeling really sick and dizzy. I almost couldn't get out of bed. It was like a truck had hit my head. Around evening, I felt a lot better especially after sleeping through most of the day.",
		spotify: {
			artist: "STAYC",
			album: "STEREOTYPE",
			song: "SLOW DOWN",
			link: "https://open.spotify.com/track/4SiwxGPQzlG2r4zatpEzLc?si=034da2a89a6447c4"
		},
		resonatedLyrics: [
			"모든 건 변하듯 지금 네 맘",
			"변할지 몰라 장담하지 마",
			"너무나 빠른 시작",
			"빨리 끝나게 돼 oh oh"
		]
	},
	{
		status: "above-average",
		reason: "In the evening, I played Valorant with friends. The games were pretty hyped and we ended on a win, which actually completed the night.",
		spotify: {
			artist: "Ariana Grande",
			album: "thank u, next",
			song: "thank u, next",
			link: "https://open.spotify.com/track/3e9HZxeyfWwjeyPAMmWSSQ?si=814b8da8a05c47b0"
		},
	},
	{
		status: "above-average",
		reason: "I tried to get back on messaging some of my friends and reconnecting with others, and it was okay.",
		spotify: {
			artist: "Coyote Theory",
			album: "Color",
			song: "This Side of Paradise",
			link: "https://open.spotify.com/track/79EkGysjP2dL5GdpeQjRxT?si=1c1c7e032c5a4f07"
		},
	},
	{
		status: "good",
		reason: "In the morning, I watched Where the Crawdads Sing with my friends and it was a really good movie. I'm not sure if this is a sign of me healing from the past, but I'm feeling less and less anxious.",
	},
	{
		status: "below-average",
		reason: "I played Valorant with Rachel, though, and it was pretty funny. I made one massive slip-up and we were both laughing. The day was fun, but I barely",
		spotify: {
			artist: "Seal",
			album: "Soul",
			song: "Stand by Me",
			link: "https://open.spotify.com/track/5pztwVl6brVgqYjYQ93us6?si=841891ba505042b8"
		},
	},
	{
		status: "awful",
		icon: "sentiment_dissatisfied",
		reason: "dn't beomething. spends thd ran to myo N then whI ktried to sleep ant on crying an had tel was the ost at theent.",
		spotify: {
			artist: "Jacob Collier",
			album: "Djesse Vol. 3",
			song: "Sleeping On My Dreams",
			link: "https://open.spotify.com/track/4mTd21pyWajN252LcouVIm?si=66b182b42403440a"
		},
	},
	{
		status: "above-average",
		title: "Back to Our Regularly Scheduled Programming",
		reason: "This day was just weird, but things did return back to our regularly scheduled programming.",
		spotify: {
			artist: "Taylor Swift",
			album: "1989 (Deluxe)",
			song: "Clean",
			link: "https://open.spotify.com/track/1NmVZsG18CzCAtw7rnV3yA?si=1ff537b961d84de1"
		},
	},
	{
		status: "above-average",
		reason: "I watched My Happy Marriage.",
		spotify: {
			artist: "aespa",
			album: "Savage - The 1st Mini Album",
			song: "YEPPI YEPPI",
			link: "https://open.spotify.com/track/3UKKwGrpWWamc0XNSKXjmz?si=898a6198fc9c45b1"
		},
		resonatedLyrics: [
			"자 이제부터 시작이야",
			"우리들의 History",
			"빠져들 준비해 Hey",
			"aespa!"
		]
	},
	{
		status: "above-average",
		icon: "celebration",
		title: "Happy Birthday, Little Sister!",
		reason: "Also, my sister and I went out to eat dinner and celebrate their birthday. They recalled so many of our childhood memories and told me how we were so close when we were in elementary. I haven't had quality time with my sister in a while so this was a nice change of pace to my usual evenings, plus I got to go outside.",
		spotify: {
			artist: "Girls' Generation-Oh!GG",
			album: "Lil' Touch - The 1st Single",
			song: "Fermata",
			link: "https://open.spotify.com/track/7zosXagdBaf6YKxQzqYkIB?si=aa07ea5938e841ca"
		},
		resonatedLyrics: [
			"내 맘속의 첫 쉼표",
			"우완벽한 세상 비록 아닐지라도",
			"여유 속에 삶은 달라져 첫 시도"
		]
	},
	{
		status: "above-average",
		reason: "I enjoyed my usual day. I got teased and it was pretty funny. In the evening, I played Phasmophobia with some of my work friends.",
		spotify: {
			artist: "Girls' Generation-Oh!GG",
			album: "Lil' Touch - The 1st Single",
			song: "Fermata",
			link: "https://open.spotify.com/track/7zosXagdBaf6YKxQzqYkIB?si=aa07ea5938e841ca"
		},
	},
	{
		status: "good",
		spotify: {
			artist: "AJR",
			song: "Way Less Sad",
			album: "OK ORCHESTRA",
			link: "https://open.spotify.com/track/6YIivt0G3ZUuNrM62jp9pL?si=4eae2689f05d486d"
		},
		resonatedLyrics: [
			"Well, I can't fall asleep and I'm losin' my mind",
			"'Cause it's half-past three and my brain's on fire",
			"I've been countin' sheep but the sheep all died",
			"And I'm tryin' too hard but I can't not try",
			"",
			"Well, I can't fall asleep and I'm losin' my mind",
			"'Cause it's half-past three and my brain's on fire (brain's on fire)",
			"I've been countin' sheep but the sheep all died",
			"And I'm not dead yet, so I guess I'll be alright",
		]
	},
	{
		status: "below-average",
		reason: "I spent most of my day sleeping. I don't even recall much of what happened this day.",
		spotify: {
			artist: "AJR",
			song: "Way Less Sad",
			album: "OK ORCHESTRA",
			link: "https://open.spotify.com/track/6YIivt0G3ZUuNrM62jp9pL?si=4eae2689f05d486d"
		},
		resonatedLyrics: [
			"No, I ain't happy yet",
			"But I'm way less sad",
		]
	},
	{
		status: "special",
		icon: "block",
		title: "Shell Shocked through the Threshold",
		reason: "I am extremely shell shocked. I actually can't believe it. I can't believe it, I can't believe it, I can't believe it. I feel like I crossed a line that I shouldn't have, like I crossed my personal threshold. Why the fuck did I do that? There's no going back from this.",
		spotify: {
			artist: "SEVENTEEN",
			album: "SEVENTEEN 10th Mini Album 'FML'",
			song: "F*ck My Life",
			link: "https://open.spotify.com/track/3tgWMPOY4stCdKYj5NjrAe?si=4d3cc388b1404286"
		}
	},
	{
		status: "excellent",
		title: "Beyond the Threshold",
		reason: "Damn, I'm good. Still, I'm already here, beyond the threshold. I feel so weird about crossing it yesterday but I don't give a flying fuck now. Who cares. We're already here haha. In the evening, I got to call my best friend and it's been more than half a year since we last talked.",
		spotify: {
			artist: "Olivia Rodrigo",
			song: "good 4 u",
			album: "SOUR",
			link: "https://open.spotify.com/track/4ZtFanR9U6ndgddUvNcjcG?si=ec18cce4f5dd42e2"
		},
	},
	{
		status: "above-average",
		reason: "I had fun playing some games of Phasmophobia with friends.",
	},
	{
		status: "above-average",
		reason: "We tried to watch Pearl today, but we couldn't finish it. It was okay, though. I changed my wallpaper. I'm starting to get more and more apathetic with things now. Maybe this is me having it all settle in like this.",
		spotify: {
			artist: "B.o.B, Taylor Swift",
			album: "Strange Clouds",
			song: "Both of Us (feat. Taylor Swift)",
			link: "https://open.spotify.com/track/3r9bgSJlJz2zlevcBRYXko?si=973ffdb0474e4a29"
		},
	},
	{
		status: "above-average",
		reason: "We finished watching Pearl today. I got to tell my friends about that thing that happened last Sunday and they were so shocked and in disbelief. It wasn't that bad, honestly.",
		spotify: {
			artist: "Powfu",
			album: "poems of the past",
			song: "death bed (coffee for your head)",
			link: "https://open.spotify.com/track/5TEH4r5OBFcKZJBjF4qOxL?si=b93882332e354e94"
		},
	},
	{
		status: "above-average",
		reason: "Today was kinda weird. I'm mostly happy on one hand because Aespa got to release their new album and I got NewJeans photocards, but on the other, I'm kind of feeling apathetic towards everything today. It was weird, I felt unattached from everything. Still, I had fun, I played Phasmophobia with friends from work, and generally enjoyed this day.",
		spotify: {
			artist: "aespa",
			album: "Better Things",
			song: "Better Things",
			link: "https://open.spotify.com/track/6zZWoHlF2zNSLUNLvx4GUl?si=b068aaf61bfa4bb4"
		},
	},
	{
		status: "above-average",
		title: "Time Alone",
		reason: "Wow, I actually spent most of the day alone. For the bulk of the day, I was truly alone. I'm not sure if this feeling is something I should get used to, but it was kind of a deafening silence. I just watched YouTube for a whole day. It was boring but I could still recall a time where my daily life was like this.",
		spotify: {
			artist: "aespa",
			album: "Better Things",
			song: "Better Things",
			link: "https://open.spotify.com/track/6zZWoHlF2zNSLUNLvx4GUl?si=b068aaf61bfa4bb4"
		},
	},
	{
		status: "good",
		reason: "I actually was able to meet up with my friends today. It was fun, I didn't think anything else of it. It was just another meetup with a friend. Time flew by, though. We met at 3:00 p.m. and said goodbye at 7:00 p.m. No way 4 hours just passed by just like that. In the evening, I played with my friends' cousin for Phasmophobia and it was fun.",
		spotify: {
			artist: "NewJeans",
			album: "NewJeans 2nd EP 'Get Up'",
			song: "ASAP",
			link: "https://open.spotify.com/track/5fpyAakgFOm4YTXkgfPzvV?si=8c05d33dadde40ef"
		},
		resonatedLyrics: [
			"There's this one more thing",
			"I'll show you come with me",
			"So much to do and lots to see",
			"",
			"Just for a minute"
		]
	},
	{
		status: "above-average",
		reason: "The next day was nothing different, but started on a holiday. I had to worry about some things for Sportstival this weekend, but it was alright. I was able to handle it. I got to play Phasmophobia and it was a pretty fun, few rounds. The evening was fun as well.",
		spotify: {
			artist: "Charlie Puth, Jung Kook",
			album: "Left and Right (feat. Jung Kook of BTS)",
			song: "Left and Right (feat. Jung Kook of BTS)",
			link: "https://open.spotify.com/track/0mBP9X2gPCuapvpZ7TGDk3?si=d35dba94d48646c2"
		},
		resonatedLyrics: [
			"Memories follow me left and right",
			"I can feel you over here, I can feel you over here",
			"You take up every corner of my mind",
			"(What you gon' do now?)"
		]
	},
	{
		status: "good",
		reason: "Things were turbulent today, but for the most part, I was able to handle my own turbulence and this was actually the only good day with a lot of struggle in recent months. I like having deep conversations about things, even though I'm mostly on the \"support\" side of things.",
		spotify: {
			artist: "Fergie",
			album: "The Dutchess Deluxe",
			song: "Big Girls Don't Cry (Personal)",
			link: "https://open.spotify.com/track/67A8bOJJ4hsIJRKJqk0pkQ?si=3dc3cf33712c4dd3"
		},
	},
	{
		status: "above-average",
		reason: "I got to watch Stephanie Soo once again and I got a lot of sleep in the evening.",
		spotify: {
			artist: "Lady Gaga, Ariana Grande",
			album: "Chromatica",
			song: "Rain On Me (with Ariana Grande)",
			link: "https://open.spotify.com/track/7ju97lgwC2rKQ6wwsf9no9?si=dc4730add8444c78"
		},
	},
	{
		status: "above-average",
		reason: "It was your average, fun day: playing Phasmophobia with friends, enjoying my daily routine.",
		spotify: {
			artist: "Lady Gaga, Ariana Grande",
			album: "Chromatica",
			song: "Rain On Me (with Ariana Grande)",
			link: "https://open.spotify.com/track/7ju97lgwC2rKQ6wwsf9no9?si=dc4730add8444c78"
		},
	},
	{
		status: "below-average",
		reason: "I was so stressed out about trying to prepare for my company's sports event tomorrow. I'm nervous and excited at the same time, but it sucks having to do these last-minute preparation and changes.",
		spotify: {
			artist: "Lady Gaga, Ariana Grande",
			album: "Chromatica",
			song: "Rain On Me (with Ariana Grande)",
			link: "https://open.spotify.com/track/7ju97lgwC2rKQ6wwsf9no9?si=dc4730add8444c78"
		},
	},
	{
		status: "special",
		title: "It's A Sports Thing!",
		icon: "sports_soccer",
		reason: `
		I was so worried for this day, I couldn't sleep properly.

		I had set several alarms to go off because I did not want to be late for the event and kind of ruin the whole thing. Thankfully, I woke up right on time and my alarms all worked. And in the morning, I got to meet up with my friends and a few colleagues for preparation. We stopped by McDonald's first, though, and I got to have my morning coffee with that whole new "cereal" syrup they were offering. I could feel how tense things are because I barely got enough sleep since last night. I was able to wear my Squid Game outfit, though, so I was felt a better about my outfit for the whole thing. As we were prepping, I forgot to cut the nametags for the people there the night prior so I scrambled to get the names cut and to set up the audio for the event.

		And then the event started. We had a pretty fun start by asking the people to gather in a circle and pass a ball around to each other. Since I was one of the organizers, I couldn't really participate in the game as I was busy with other matters. When the games started, the first game was up and it was my turn to explain the mechanics. Truthfully, I understood the game well enough to explain it, but there were certain "gotchas" that I couldn't understand, so I felt a bit nervous during the whole explanation bit. But the game proceeded and everyone seemed to have a fun time. I got to play for it as well! It was **super** exhausting.

		The other games proceeded fine with no issue, with me mostly helping out with setting up the equipment and facilitating some of the games. The tug of war game seemed super fun but I only got to hold the rope when I was setting up for the teams, not actually playing with it. Same for the 3rd game as well, I only got to watch and facilitate. One aspect that I am super happy about, however, was that I got to control the music playback of the whole event. All of the songs were managed by me and it was a pretty banger playlist.

		Once the event ended, I stayed back along with some of my fellow coordinators. I was with my friends and one other person, we got to talk as we made our way to the place where we would all have lunch. Lunch time with everyone in the company was pretty fun, we had a *boodle fight* thing going on and I got to eat a lot of crabs. It was oily as hell and I only had, like, 3 cups of water which didn't feel enough for me haha. After eating, we got to socialize for a bit more while the others were leaving. I got to catch up on some friends from the company until it was a few of us left. I purposely tried to stay behind so I can socialize with a  few more friends and I played that [Chain Reaction mobile game](https://play.google.com/store/apps/details?id=com.BuddyMattEnt.ChainReaction&hl=en&gl=US) with my friends and Nicole (and I won, btw).

		It was raining so hard so I just decided to book a taxi ride home even though it was expensive as hell. When I got home, I got that package that Kai delivered! The package was left out by the rain so it got soaked, but not that much. The package did have a lot of stuff, though. It's been a really, really long time since I've gotten gifts. It meant a lot and I got a letter from them, too. I honestly didn't know what I did to deserve a friend like Kai, but I'm glad I met them.

		In the evening, I just slept and joined my college friends in our batchmate's birthday. It was really nice to have caught up with friends from college as I fell off the map after dropping out. All in all, today was a very special and eventful day.
				`,
		spotify: {
			artist: "aespa",
			album: "Better Things",
			song: "Better Things",
			link: "https://open.spotify.com/track/6zZWoHlF2zNSLUNLvx4GUl?si=b068aaf61bfa4bb4"
		},
	},
	{
		status: "bad",
		reason: "I had to reveal something that I didn't want to be revealed.",
		spotify: {
			artist: "Jon Boden, Sam Sweeney, Ben Coleman",
			album: "About Time",
			song: "How Long Will I Love You",
			link: "https://open.spotify.com/track/74RjCYWXEq02lyMumMTKDI?si=bdd2b8087c3c40be"
		},
	},
	{
		status: "below-average",
		spotify: {
			artist: "Meghan Trainor, John Legend",
			album: "Title (Deluxe)",
			song: "Like I'm Gonna Lose You",
			link: "https://open.spotify.com/track/2YlZnw2ikdb837oKMKjBkW?si=00a266cafae8408b"
		}
	},
	{
		status: "bad",
		spotify: {
			artist: "Meghan Trainor, John Legend",
			album: "Title (Deluxe)",
			song: "Like I'm Gonna Lose You",
			link: "https://open.spotify.com/track/2YlZnw2ikdb837oKMKjBkW?si=00a266cafae8408b"
		},
		resonatedLyrics: [
			"I woke up in tears with you by my side",
			"A breath of relief, and I realized",
			"No, we're not promised tomorrow"
		]
	},
	{
		status: "above-average",
		reason: "Things were pretty okay today. It was your standard affair, playing Phasmo and having a fun day. I thought things would be different today, but no, things remained the same for the most part.",
		spotify: {
			artist: "aespa",
			album: "Savage - The 1st Mini Album",
			song: "YEPPI YEPPI",
			link: "https://open.spotify.com/track/3UKKwGrpWWamc0XNSKXjmz?si=898a6198fc9c45b1"
		},
	},
	{
		status: "above-average",
		reason: "Other than that, things were pretty normal today, as far as things would go. I played Phasmophobia with friends and it was pretty fun.",
		spotify: {
			artist: "Taylor Swift",
			album: "Hannah Montana The Movie",
			song: "Crazier",
			link: "https://open.spotify.com/track/5vyxXfD5gLlyPxGZMEjtmd?si=e02a949e392d4652"
		},
	},
];

export default augustMap;
